module.exports = __webpack_public_path__ + "static/media/vdo1.680e1515.mp4";